import React, { useContext, useEffect, useState } from 'react';
import { IProps } from './types';
import { AlignmentIcon } from '@assets/icons/alignmentIcon';
import { AlignLeftIcon } from '@assets/icons/alignLeftIcon';
import { AlignRightIcon } from '@assets/icons/alignRightIcon';
import ClickOutside from '@components/ClickOutside';
import Tooltip from '@components/Tooltip';
import * as S from './styles';
import C from '@assets/themes/colors';
import { ITextAttributes } from 'routes/private/Editor/types';
import { Context } from "routes/private/Editor/Context";
import { findElementById, findCommonAttributeValue } from "@utils/editor";

const FontAlignmentCommandOption : React.FC<IProps> = () => {
  let { editorStatus, data, onCommandChange} = useContext(Context);
  const [isSelected, setIsSelected]= useState(false);
  const [selectedOption, setSelectedOption]= useState<string | undefined>("");

  useEffect(() => {
    const aligment = findCommonAttributeValue(editorStatus.selectedElementsId, data, "textAlign");
    setSelectedOption(aligment);
    setIsSelected(false);
}, [editorStatus.selectedElementsId.length, editorStatus.selectedElementsId[0], data]);

  const SetFontAlignment = (value: string) => {  
    setSelectedOption(value);
    onCommandChange("textAlign", value);          
  }

  return (
    <S.Root>
      <ClickOutside onClickOutside={()=> setIsSelected(false)}>
        <Tooltip tip={"Text Alignment"} boxStyle={isSelected ? {display:'none'}:undefined}>
          <S.ButtonContainer onClick={()=> setIsSelected(!isSelected)} isSelected={selectedOption ? true : isSelected}>
            {selectedOption==="left" ? <AlignLeftIcon fill="#CCCCCC"/> :
            selectedOption==="right" ? <AlignRightIcon fill="#CCCCCC"/> :
            <AlignmentIcon/>}
          </S.ButtonContainer>
        </Tooltip>
        <S.OptionsList style={{ display: isSelected ? "flex" : "none"}}>
            <Tooltip tip={"Left"} style={{backgroundColor: C.DARKEST_GRAY}}>
              <S.ButtonOption onClick={()=> SetFontAlignment("left")} isSelected={selectedOption=="left" ? true : false}>
                <AlignLeftIcon/>
              </S.ButtonOption>
            </Tooltip>
            <Tooltip tip={"Center"} style={{backgroundColor: C.DARKEST_GRAY}}>
              <S.ButtonOption onClick={()=> SetFontAlignment("center")} isSelected={selectedOption=="center" ? true : false}>
                <AlignmentIcon fill="#424C57"/>
              </S.ButtonOption>
            </Tooltip>
            <Tooltip tip={"Right"} style={{backgroundColor: C.DARKEST_GRAY}}>
              <S.ButtonOption onClick={()=> SetFontAlignment("right")} isSelected={selectedOption=="right" ? true : false}>
                <AlignRightIcon/>
              </S.ButtonOption>
            </Tooltip>               
        </S.OptionsList>
      </ClickOutside>
    </S.Root>
  );
}

export default FontAlignmentCommandOption;